export default function AnchorNav({ items = [] }) {
  if (!items || items.length === 0) return null;

  return (
    <div className="hidden lg:flex md:items-center md:justify-around py-3 sticky top-0 z-30">
      <div className="bg-white rounded shadow text-center mt-6 px-3">
        {items.map((item, index) => (
          <a
            key={index}
            href={`#${item.slug}`}
            className="font-bold text-cornflower hover:text-rose text-sm py-2 px-3 text-center inline-block"
          >
            {item.title}
          </a>
        ))}
      </div>
    </div>
  );
}
